import { Displays } from "components";
import { ExpandedRankContentStyled } from "./styled";
import renderTooltipCell from "utils/functions/renderTooltipCell";

const ExpandedRankContent = ({ isDepartmentMode, row, onOpenMemberModal }) => {
  const items = isDepartmentMode ? row?.departments : row?.members;
  const hasData = Array.isArray(items) && items?.length > 0;
  return (
    <ExpandedRankContentStyled>
      <div className="expanded_label">10 อันดับสูงสุด</div>
      <div className="sub_rows_container">
        {!hasData ? (
          <div className="sub_empty">ไม่พบข้อมูล</div>
        ) : isDepartmentMode ? (  //แบบ department
          items.map((dept) => (
            <div key={dept.id} className="sub_row sub_row_department">
              <div className="sub_rank">อันดับที่ {dept.rank}</div>
              <div className="sub_name_purple">{dept.name_th}</div>
              <div>
                <Displays.MetricCell
                  label={`จำนวน${dept.unit_category}สะสม`}
                  value={dept.total_achieved_amount}
                  unit={dept.unit_category || "ก้าว"}
                />
              </div>
              <div>
                <Displays.MetricCell
                  label="จำนวน"
                  value={dept.total_participants}
                  unit="คน"
                />
              </div>
              <button
                type="button"
                className="sub_action"
                onClick={() => onOpenMemberModal(dept)}
              >
                ดูสมาชิก
              </button>
            </div>
          ))
        ) : (
          //แบบ team
          items.map((m) => (
            <div key={m.id} className="sub_row sub_row_team">
              <div className="sub_rank">อันดับที่ {m.rank}</div>
              <div className="sub_name_purple">{renderTooltipCell({ tooltipId: `tooltipName${m.id}`, valueTooltip: <span>{m.name}</span>, value: <span>{m.name}</span> })}</div>
              <div className="sub_company_semibold">{renderTooltipCell({ tooltipId: `tooltipCompany${m.id}`, valueTooltip: <span>{m.company}</span>, value: <span>{m.company}</span> })}</div>
              <div className="sub_dept_regular">{m.department}</div>
              <div>
                <Displays.MetricCell
                  label={`จำนวน${m.unit_category}สะสม`}
                  value={m.total_achieved_amount}
                  unit={m.unit_category || "ก้าว"}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </ExpandedRankContentStyled>
  );
};

export default ExpandedRankContent;
